
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";
import {
  requiredRule,
  maxLengthRule,
  minLengthRule,
} from "@/services/helpers/validation-rules";

export default Vue.extend({
  name: "Create",

  data: () => ({
    model: {} as any,
    items: [] as Array<any>,
    errorMessages: {} as any,
  }),

  computed: {
    computedRules(): object {
      return {
        min: minLengthRule.bind(this),
        max: maxLengthRule.bind(this),
        required: requiredRule.bind(this),
      };
    },
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const response = await API.studyPrograms().getList();
      next((vm) => {
        vm.setServerResponse(response);
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    setServerResponse(items: any) {
      this.items = items;
    },
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as any).validate()) {
          await this.$API.specialities().create(this.model);
          await this.$router.push("/specialities");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global-alert.successful_create")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;
          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
  },
});
